export class RegistrationContact {

  email: string;
  phoneMobile: string;
  phoneCommercial: string;
  phoneResidential: string;

  constructor() {
    this.email = null;
    this.phoneMobile = null;
    this.phoneCommercial = null;
    this.phoneResidential = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/registrationcontact.ts